module.exports = __webpack_public_path__ + "static/who-was-abraham-lincoln-5b042664ae094a25fae22e39038390e2.jpg";